import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { languages } from "../../constants/languages";
import TournamentTypes from "../../constants/TournamentTypes";
import {
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Slider,
} from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import { countries } from "../../constants/Countries";
import LocationAutoComplete from "../schedule/LocationAutoComplete";

const TournamentDetails = (props) => {
  const genders = [
    languages.general.native.men,
    languages.general.native.women,
  ];

  const labels = {
    1: languages.general.native.level1,
    2: languages.general.native.level2,
    3: languages.general.native.level3,
  };

  const [hover, setHover] = React.useState(-1);

  return (
    <>
      {/* Choose sport */}
      <Autocomplete
        id="tournament-type"
        options={TournamentTypes}
        groupBy={(option) => option.sportType}
        getOptionLabel={(option) => option.name}
        renderOption={(option) => (
          <React.Fragment>
            <img
              src={option.icon}
              alt={option.name + "icon"}
              style={{ height: 15, width: 15, marginRight: 15 }}
            />
            {option.name}
          </React.Fragment>
        )}
        noOptionsText={languages.general.native.notFound}
        renderInput={(params) => (
          <TextField
            {...params}
            label={languages.general.native.category}
            style={{ width: "100%", marginBottom: 20 }}
          />
        )}
        onChange={(e, newValue) => {
          props.handleSportChange(e, newValue);
        }}
        value={TournamentTypes.find((t) => t.id === props.sport) || null}
      />

      {/* Choose gender */}
      <FormControl style={{ width: "100%", marginBottom: 40 }}>
        <InputLabel>{languages.general.native.gender}</InputLabel>
        <Select
          labelId="gender-label"
          id="gender"
          multiple
          value={props.gender}
          onChange={props.handleGenderChange}
          input={<Input />}
          renderValue={(selected) => selected.map((s) => genders[s]).join(", ")}
        >
          {genders.map((g, i) => (
            <MenuItem key={i} value={i}>
              <Checkbox checked={props.gender.indexOf(i) > -1} />
              <ListItemText primary={g} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Choose age group */}
      <div style={{ width: "100%", marginBottom: 20 }}>
        <FormLabel>{languages.general.native.age}</FormLabel>
        <Slider
          value={props.age}
          onChange={props.handleAgeChange}
          valueLabelDisplay="auto"
          aria-labelledby="age-slider"
        />
      </div>

      {/* Choose playing level */}
      <FormLabel>{languages.general.native.level}</FormLabel>
      <div
        style={{
          marginBottom: 20,
          marginTop: 3,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Rating
          name="level"
          value={props.level}
          precision={1}
          max={3}
          size="large"
          onChange={(event, newValue) => {
            props.handleLevelChange(newValue);
          }}
          onChangeActive={(event, newHover) => {
            setHover(newHover);
          }}
        />
        {props.level !== null && (
          <Box ml={2}>{labels[hover !== -1 ? hover : props.level]}</Box>
        )}
      </div>

      <div style={{ width: "100%", marginBottom: 20 }}>
        <LocationAutoComplete
          label={languages.upgrade.place}
          value={props.placeSearch}
          handleChange={props.handlePlaceSearchChange}
          setName={props.setPlaceName}
          disableFreeSolo
        />
      </div>

      <FormControl style={{ width: "100%" }}>
        <InputLabel htmlFor="tournamentCountry">
          {languages.upgrade.country}
        </InputLabel>
        <Select
          value={props.country}
          onChange={props.handleCountryChange}
          inputProps={{
            name: "country",
            id: "tournamentCountry",
          }}
        >
          {/* <option style={{ textDecoration: "italic" }} value="" disabled>
            {languages.upgrade.country}
          </option> */}
          {countries.map((country) => (
            <MenuItem key={country.code} value={country.code}>
              {country.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default TournamentDetails;
